import React, { useCallback, useEffect, useRef, useState } from 'react';
import { reformat } from '../../../hooks/useMyStrings';
import useWebSocketCaller from '../../../hooks/useWebSocketCaller';
import { useFolderListenerContext } from '../../../providers/FolderListenerContextProvider';
import './CreateSubFolder.css';
import ConfigErrorMsg from '../cells/ConfigErrorMsg';

const CreateSubFolder = ({parentFolderPath, hideMe, withError, folderNameInProgress}) => {
  const {sendMessage}                 = useWebSocketCaller();
  const {tagFolderCreatedError, tagCreateFolderInProgress, clearErrorFolderCreated, clearFolderKInfo}  = useFolderListenerContext();
  const [content, setContent]         = useState('');
  const [errSubject, setErrSubject]   = useState(null);
  const [errBody, setErrBody]         = useState(null);
  const [errCause, setErrCause]       = useState(null);
  const [style, setStyle]             = useState('createSubFolder');
  const focusRef                      = useRef(null);

  useEffect(()=>{
    if (withError) {
      const {newKey, message, suggestion, cause} = withError;
      setContent(newKey);
      setErrSubject(message);
      setErrBody(suggestion);
      setErrCause(cause)
      setStyle('createSubFolder error');
      focusRef.current.focus();
    }
  }, [withError]);

  useEffect(()=>{
    if (folderNameInProgress) {
      setContent(folderNameInProgress);
      setStyle('createSubFolder inProgress');
    }
  }, [folderNameInProgress]);

  const updateContent = useCallback((e)=>{
    const update = reformat(e.target.value);
    setErrSubject(update.includes('/') ? 'Char `/` is now allowed in folder names' : null);
    const fixed = update.replace('/', '');
    setContent(fixed);
  }, []);


  const closeMe = useCallback(()=>{
    if (withError) {
      clearErrorFolderCreated(withError)
        .then(hideMe);
    }
    else {
      hideMe();
    }
  }, [clearErrorFolderCreated, hideMe, withError]);


  const save = useCallback(()=>{
    if (content) {
      tagFolderCreatedError(withError, false)
        .then(()=> tagCreateFolderInProgress(parentFolderPath, content, true))
        .then(()=>sendMessage('create-config-folder', {
          path: parentFolderPath,
          folder: content
        }));
    }
  }, [tagFolderCreatedError, tagCreateFolderInProgress, parentFolderPath, content, sendMessage, withError]);

  //---  KeyDown    [Enter] / [Esc]   ----------
  //
  const handleKeyDown = useCallback((e) => {
      if (e.key === 'Enter') {
        save();
      }
      else if (e.key === 'Escape') {
        closeMe();
      }
  }, [save, closeMe]);


  
  return (
    <div className={style}>
      {errSubject && <ConfigErrorMsg subject={errSubject} body={errBody} cause={errCause} />}
      <input  ref={focusRef}
              type='text' 
              value={content}
              className='createSubFolderInput' 
              onChange={updateContent}
              onBlur={save}
              autoFocus={true}
              placeholder='new-folder-name'
              tabIndex='1'
              onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default CreateSubFolder;